const environment = {
  debug: false,
  apiKey: "ZGlhYUBjYW5ndXJ1LmNvbS5hdQ:Q6Tz1vBKgAAJlAxsY31um",
  baseUrl: "https://api.d-id.com/",
};

export default environment;
